// Temporarily enabled in prod to debug Facebook 401 issues reported by users.
const FORCE_PROD_LOGS = true;
const isDev = process.env.NODE_ENV !== "production";
const enabled = isDev || FORCE_PROD_LOGS;

const logger = {
  log: (...args) => enabled && console.log(...args),
  warn: (...args) => enabled && console.warn(...args),
  error: (...args) => enabled && console.error(...args),
  info: (...args) => enabled && console.info(...args),
  debug: (...args) => enabled && console.debug(...args),
};

export default logger;
